"use client";

import { ErrorDisplayProps } from "./types";

export const ErrorDisplay = ({ error, retrying, handleRetry }: ErrorDisplayProps) => {
  return (
    <div className="col-span-full flex flex-col justify-center items-center min-h-[400px] w-full px-4">
      <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-8 shadow-xl border border-blue-100/10 max-w-lg w-full text-center animate-fadeIn">
        <div className="mb-6 flex justify-center">
          {error.includes("alta demanda") ? (
            <div className="w-20 h-20 rounded-full bg-amber-50 flex items-center justify-center mb-4 mx-auto animate-soft-bounce">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          ) : error.includes("conexión") ? (
            <div className="w-20 h-20 rounded-full bg-blue-50 flex items-center justify-center mb-4 mx-auto animate-pulse">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0" />
              </svg>
            </div>
          ) : (
            <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mb-4 mx-auto animate-pulse">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
          )}
        </div>

        <h3 className="text-xl font-bold text-gray-800 mb-2">
          {error.includes("alta demanda")
            ? "El servidor está ocupado"
            : error.includes("conexión")
              ? "Conexión lenta detectada"
              : "¡Ups! Algo salió mal"}
        </h3>

        <p className="text-gray-600 mb-6">
          {error}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={handleRetry}
            disabled={retrying}
            className={`px-4 py-2 rounded-md transition-colors ${retrying
                ? 'bg-gray-400 text-white cursor-not-allowed'
                : 'bg-blue-500 text-white hover:bg-blue-600'
              }`}
          >
            {retrying
              ? 'Reintentando...'
              : 'Intentar nuevamente'}
          </button>
        </div>
      </div>
    </div>
  );
}; 